import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import LocationOnIcon from '@material-ui/icons/LocationOn';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const styles = theme => ({
    rowIconButtonRoot: {
        height: 40
    }
});

class BudgetLineComponent extends React.Component {

    toggleRowMenu = (event, el, index) => {
        const { onElementSelect, toggleRowMenu } = this.props;
        const { currentTarget } = event;

        if (el !== null && el !== undefined) {
            onElementSelect(el, index);
        }

        toggleRowMenu(currentTarget);
    }

    render() {
        const { classes, budgetLine, budgetLineIndex, children, toggleRowMenu, columns  } = this.props;
        return (
            <React.Fragment>
                <TableRow>
                    <TableCell className="icon-cell"><LocationOnIcon /></TableCell>
                    {
                        columns &&
                        [].concat(columns).map((col, colIndex) => <TableCell className={col.cellClass || ''} numeric={col.numeric} key={`table_row_${budgetLine.id}_cell_${colIndex}`}>{budgetLine[col.field]}</TableCell>)
                    }
                    {
                        toggleRowMenu && 
                        <TableCell numeric>
                            <Tooltip title="Options">
                                <IconButton classes={{ root: classes.rowIconButtonRoot }} aria-label="Options" onClick={event => this.toggleRowMenu(event, budgetLine, budgetLineIndex)}>
                                    <MoreVertIcon />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    }
                </TableRow>
                {children}
            </React.Fragment>
        );
    }
}

BudgetLineComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired
};

export default withStyles(styles)(BudgetLineComponent);


// WEBPACK FOOTER //
// ./src/Components/Presentation/Campaigns/MediaPlan/BudgetLineComponent.js